// import { useLocation } from "react-router-dom";

import SuccessIcon from "../../../../assets/images/assessment-success.svg";
// import FailIcon from "../../../../assets/images/assessment-fail.svg";
import CheckIcon from "../../../../assets/images/assessment-check.svg";
import CrossIcon from "../../../../assets/images/assessment-x.svg";
import AssessmentIcon from "../../../../assets/images/pre-assessment.svg";

import Modal from "../../../modal/Modal";

import { IS_RETAKE_ATTEMPT, LMS_COURSE_NAME } from "../../../../utils/cookiesmanager";

import styles from "./styles.module.scss";

const CourseRetakeStatusModal = (props) => {
  const { show, marks , handleContinue , handleTryAgain , passingMarks = 60 } = props;

  const moduleName = localStorage.getItem(LMS_COURSE_NAME);

  const isRetakeAttempt = localStorage.getItem(IS_RETAKE_ATTEMPT)

  const isTryAgainOptionAvailable = JSON.parse(isRetakeAttempt) ? true :  false;

  return (
    <>
      <Modal visible={show}>
        <div className={styles["assessment-wrapper"]}>
          {marks?.percentage >= passingMarks ? (
            <div className={styles["success-image"]}>
              <img src={SuccessIcon} alt="success" />
            </div>
          ) : (
            <div className={styles["success-image"]}>
              <img src={AssessmentIcon} alt="fail" />
            </div>
          )}
          {marks?.percentage >= passingMarks ? (
            <div className={styles.title}>Congratulations</div>
          ) : (
            !isTryAgainOptionAvailable ? '' :<div className={styles.title}>Assessment Completed Successfully</div>
          )}

        {   marks?.percentage >= passingMarks ?       <div className={styles.description}>
            You have completed {moduleName} . you score
            <span
              className={`${styles["numeric-result"]} ${
                marks?.percentage < passingMarks ? styles["low-score"] : ""
              }`}
            >
              {" "}
              {`${marks?.percentage || 0}%`}
            </span>
          </div>:
          <p className={styles.text}>The Certificate of Excellence is awarded to learners who meet the excellence score criteria.</p>}
          <div className={styles["result-wrapper"]}>
            {marks?.result?.map((item, index) => (
              <div className={styles.result} key={item.id}>
                {item?.isCorrect === 1 ? (
                  <div className={styles["result-check"]}>
                    <img src={CheckIcon} alt="check" />
                  </div>
                ) : (
                  <div className={styles["result-cross"]}>
                    <img src={CrossIcon} alt="cross" />
                  </div>
                )}

                <div>Question {index + 1}</div>
              </div>
            ))}
          </div>
          {marks?.percentage >= passingMarks ? (
            <div className={styles["button-wrapper"]}>
              <button className={styles.button} onClick={handleContinue}>Continue</button>
            </div>
          ) : (
            <div className={styles["button-wrapper"]}>
              <button className={styles.button} onClick={handleTryAgain}>Back to Course</button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CourseRetakeStatusModal;
